'use client';
import { Menu, Transition } from '@headlessui/react';
import { usePathname } from 'next/navigation';

const MainMenuExpanded = ({ main_menu = [], shrinkHeight = false }) => {
  const pathName = usePathname();

  if (!main_menu || main_menu.length === 0) {
    return null;
  }

  return (
    <Menu as="div" className="hidden h-full md:block">
      {({ open }) => (
        <>
          <Menu.Button
            aria-label="Open en sluit assortiment menu"
            onMouseDown={(e) => e.preventDefault()}
            className={`flex items-center gap-2 font-medium transition-all duration-300 border-none rounded-10 outline-none text-dark-text h-full hover:bg-body group !ring-0 px-4 ${open ? 'bg-body' : ''}`}
          >
            <span className="text-sm font-medium leading-none">Assortiment</span>
            <span className={`relative w-3 h-2 text-primary ${open ? "!mb-1" : ""}`} aria-hidden="true">
              <span
                className={`absolute block h-[0.125rem] w-full bg-current top-0 rounded-full transition-all ${open ? "rotate-45 !top-[0.3125rem]" : ""
                }`}
              />
              <span
                className={`absolute block h-[0.125rem] w-full bg-current top-1/2 rounded-full transition-all ${open ? "w-0 opacity-0" : ""
                }`}
              />
              <span
                className={`absolute block h-[0.125rem] w-full bg-current top-full rounded-full transition-all ${open ? "-rotate-45 !top-[0.3125rem]" : ""
                }`}
              />
            </span>
          </Menu.Button>

          <Transition show={open}>
            <Transition.Child
              enter="transition-opacity ease-linear duration-150"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div
                className={`fixed inset-x-0 bottom-0 z-40 bg-[#252B30CC] ${shrinkHeight ? "md:top-[8rem]" : "md:top-[10rem]"}`}
                aria-hidden="true"
              />
            </Transition.Child>

            <Transition.Child
              enter="transition-opacity ease-out duration-150"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-in duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Menu.Items className="absolute left-0 right-0 z-50 mt-2 top-full focus:outline-none">
                <div className="relative z-50 flex w-full mx-auto overflow-x-auto bg-white border shadow-lg py- max-w-app rounded-10 whitespace-nowrap" id="modalSelector">
                  {main_menu?.map((item, idx) => {
                    const { ID, title: itemTitle, slug: itemSlug, children } = item || {};
                    const urlNotValid = itemSlug?.trim() === '#' || itemSlug?.trim() === '' || itemSlug == null;
                    const isActiveMain = itemSlug == pathName;

                    return (
                      <div
                        key={ID ?? `item-${idx}`}
                        className={`flex flex-col min-w-[calc(100%/5)] px-4 py-6 ${idx !== 0 ? 'border-l' : ''}`}
                      >
                        {itemSlug && !urlNotValid ? (
                          <a
                            href={itemSlug}
                            title={itemTitle}
                            className={`px-4 mb-4 text-sm font-bold no-underline text-dark-text ${isActiveMain ? 'text-primary' : ''}`}
                          >
                            {itemTitle}
                          </a>
                        ) : (
                          <span className="px-4 mb-4 text-sm font-bold cursor-default text-dark-text">
                            {itemTitle}
                          </span>
                        )}

                        {(children && children?.length > 0) && children.map((child, cidx) => {
                          const { ID, title: childTitle, slug: childSlug } = child || {};
                          const urlNotValid = childSlug?.trim() === '#' || childSlug?.trim() === '' || childSlug == null;
                          const isActiveChild = childSlug == pathName;

                          return (childSlug && !urlNotValid) ? (
                            <a
                              key={ID ?? `cat-${cidx}`}
                              href={childSlug}
                              title={childTitle}
                              className={`group inline-block text-dark-text px-4 py-2 my-0.5 rounded-5 text-sm transition-all duration-300 relative no-underline ${isActiveChild ? 'bg-active-background' : ''}`}
                            >
                              <span className="absolute inset-y-0 left-0 right-0 z-0 h-full transition-all duration-300 opacity-0 pointer-events-none rounded-5 bg-active-background group-hover:opacity-100" />
                              <span className="relative z-10 whitespace-nowrap">
                                {childTitle}
                              </span>
                            </a>
                          ) : (
                            <span
                              key={ID ?? `cat-${cidx}`}
                              className="inline-block text-dark-text px-4 py-2 my-0.5 rounded-5 text-15 opacity-50 cursor-not-allowed"
                            >
                              {childTitle}
                            </span>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </Menu.Items>
            </Transition.Child>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default MainMenuExpanded;
